<template>
  <div class="sorty-tab">
    <ul class="list-group">
      <li
        class="list-group-item"
        v-for="(order,index) in sortOptions"
        :key="index"
        @click.prevent="selectedSortOrderIndex = index"
								:data-test="'sortTabOrderName'+index"
								:id="'sortTabOrderName'+index"
      >
        {{ order.name}}
      </li>
    </ul>
    <button
      @click.prevent="showSortBlock(selectedSortOrderIndex)"
      class="btn btn-md add-to-cart ripplelink"
						data-test="sortTabApplyBtn"
						id="sortTabApplyBtn"
    >
      Apply
    </button>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { productApi } from '@/services/ApiServices/productApi'

export default {
	name: 'sort-tab',
	data () {
		return {
			selectedSortOrderIndex: 0,
			sortOrder: '',
			sortMethod: ''
		}
	},
	computed: {
		...mapGetters('filters', ['isFilterApplied', 'getFilterClass'])
	},
	methods: {
		...mapActions('filters', ['setSortFilterLoader']),
		// sortBlock() {
		//   this.$emit('showSortBlock', this.selectedSortOrderIndex);
		// },
		showSortBlock (index = 0) {
			if (document.querySelector('.sorty-tab').classList.contains('shown')) {
				this.sortProducts(index)
				document.querySelector('.sorty-tab').classList.remove('shown')
				document.querySelector('body').classList.remove('backdrop')
			} else {
				document.querySelector('.sorty-tab').classList.add('shown')
				// document.querySelector('body').classList.add('backdrop');
			}
		},
		sortProducts (index) {
			this.setSortFilterLoader(true)
			this.sortOrder = this.sortOptions[index].sortOrder
			this.sortMethod = this.sortOptions[index].sortMethod
			let searchKey = {}
			let urlReference = 'filteredSearchProducts'
			if (this.$route.path === '/all-products') {
				if (!this.isFilterApplied) {
					searchKey = {
						key: 'getAllProducts'
					}
				}
				urlReference = 'filteredAllProducts'
			} else if (this.$route.path === '/search-results') {
				searchKey = {
					is_a_category: this.$route.query.is_a_category,
					category_id: this.$route.query.category_id,
					search_name: this.$route.query.search_name
				}
			} else if (this.$route.path === '/product-list') {
				searchKey = {
					is_a_category: this.$route.query.is_a_category,
					category_id: this.$route.query.category,
					name: this.$route.query.name,
					depth: this.$route.query.depth
				}
			}
			this.sortPLPProducts(searchKey, urlReference)
		},
		sortPLPProducts (searchKey, urlReference) {
			let apiData = {}
			if (this.isFilterApplied) {
				apiData = {
					filter_class: this.getFilterClass,
					query_parameter: searchKey
				}
			} else {
				apiData = { query_parameter: searchKey }
			}
			if (searchKey.key === 'getAllProducts') {
				const filterData = {
					filter_class: { filters: [], brands: [], ratings: [] }
				}
				productApi.getSearchedFilteredProducts(filterData, 'filteredAllProducts', this.sortOrder, this.sortMethod)
					.then((res) => {
						this.setSortFilterLoader(false)
					})
			} else if (apiData.filter_class) {
				productApi.getSearchedFilteredProducts(apiData,
					urlReference, this.sortOrder, this.sortMethod).then((res) => {
					this.setSortFilterLoader(false)
				})
			} else {
				urlReference = 'searchProducts'
				productApi.getSearchedFilteredProducts(apiData,
					urlReference, this.sortOrder, this.sortMethod).then((res) => {
					this.setSortFilterLoader(false)
				})
			}
		}
	},
	props: {
		sortOptions: Array
	}
}
</script>
